import { useState } from "react"
import { DataTable } from "../../DataTable/DataTable"
import { Plus } from "lucide-react"
import { AddNewCategoryModal } from "../../../shared/AddNewCategoryModal"

export function StockCategoriesView(){
    const [isLoading,setIsLoading] = useState(true)
    const [categoriesList,setCategoriesList] = useState<any[]>([])
    const [selectedCategory,setSelectedCategory] = useState<any | null>(null)
    const [showAddCategoryModal,setShowAddCategoryModal] = useState(false)

    const addCategoryButton = (
        <button
            onClick={() => setShowAddCategoryModal(true)}
            className="relative z-10 flex items-center justify-center px-4 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition-colors whitespace-nowrap"
        >
            <Plus className="w-5 h-5 mr-2" />
            <span className="whitespace-nowrap">Add Category</span>
        </button>
    );

    const columns = [
        {
            key:"name",
            title:"Name",
            width: "w-[400px]",
            render: () => (
                <div>
                    <div className="text-sm font-medium"></div>
                </div>
            ),
        },
        {
            key:"noOfProducts",
            title:"No of Products",
            width: "w-[200px]",
            render: () => (
                <div>
                    <div className="text-sm font-medium"></div>
                </div>
            ),
        },
        {
            key:"published",
            title:"Published",
            width: "w-[200px]",
            render: () => (
                <div>
                    <div className="text-sm font-medium"></div>
                </div>
            ),
        },
        {
            key:"actions",
            title:"Actions",
            width: "w-[200px]",
            render: () => (
                <div>
                    <div className="text-sm font-medium"></div>
                </div>
            ),
        },
    ]
    return(
        <div className="relative">
            <DataTable 
              data={categoriesList}
              columns={columns}
              isLoading={isLoading}
              customFilters={addCategoryButton}
            />

            {showAddCategoryModal && (
                <AddNewCategoryModal 
                  onClose={() => {
                    setShowAddCategoryModal(false)
                    setSelectedCategory(null)
                  }}
                />
            )}
        </div>
    )
}